import { buildPath } from "./buildPath";

export const circleAiAvatarSetupConversation = {
  create: () => buildPath("/internal_api/circle_ai/avatar_setup_conversation"),
};
